import { Alert, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import Header from "../../Layout/Header";
import Loader from "../../Loader/Loader";
import Pagination from "../../Pagination/Pagination";
import {
  caregiverexpressinterest,
  caregivernewbookingrequest,
  stripeurl,
} from "../../service/Mainservice";
import Profilemenu from "./Profilemenu";
import KYCPopup from "./KYC";
import "./MyBooking.css";
import moment from "moment";

const CaregiverNewBooking = () => {
  const [list, setlist] = useState();
  const [load, setload] = useState(true);
  const [currentPage, setcurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState();
  const [actionId, setactionId] = useState(false);
  const [success, setsuccess] = useState();
  const [error, seterror] = useState();
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [kyc, setkyc] = useState();
  const [url, seturl] = useState(false);

  useEffect(() => {
    getnewbooking(1);
    checkstripe();
  }, []);

  const checkstripe = async () => {
    const response = await stripeurl();
    if (response.data.url) {
      seturl(response.data.url);
      setkyc(true);
    }
  };

  const getnewbooking = async (val = 1) => {
    try {
      const response = await caregivernewbookingrequest(val);
      setlist(response.data.data);
      setcurrentPage(response.data.pagination?.current_pages || 1);
      settotalPages(response.data.pagination?.total_pages || 1);
      setload(false);
    } catch (err) {
      console.log(err);
      setload(false);
    }
  };

  const handleaction = async (id, status) => {
    setactionId(id);
    try {
      const response = await caregiverexpressinterest(id, status);
      setsuccess(response.data.message);
      setOpenSuccess(true);
      getnewbooking(currentPage);
    } catch (err) {
      console.log(err);
      seterror(err.message || err?.data?.message || "Something went wrong");
      setOpenError(true);
    } finally {
      setactionId(false);
    }
  };

  const formatDate = (value) => {
    return value ? moment(value).format("MM/DD/YY") : "N/A";
  };

  return (
    <>
      <Header title="New Booking" headerbg="upcomingbg" />
      <div className="editprofile_data">
        <Profilemenu />
        <div className="editprofile_info">
          <h2 className="editprofile_maintitle">New Booking Requests</h2>
          {list?.length > 0 ? (
            <div>
              <div className="mybooking_cardlist">
                {list.map((data) => (
                  <div className="mybooking_card modern_card" key={data.id}>
                    <div className="mybooking_card_section">
                      <div className="section_title_div">
                        <p className="section_title">Booking Request</p>
                        <p className="booking_type_badge">
                          {data.booking_type || "New Request"}
                        </p>
                      </div>
                      <div className="mybooking_card_row">
                        <div className="mybooking_cardinfo1">
                          <p>Request ID</p>
                          <h3>{data.request_id || data.id}</h3>
                        </div>
                        <div className="mybooking_cardinfo1">
                          <p>Start Date</p>
                          <h3>{formatDate(data.start_booking_date)}</h3>
                        </div>
                        {(data.booking_type === "OneTime" ||
                          data.end_booking_date) && (
                          <div className="mybooking_cardinfo1">
                            <p>End Date</p>
                            <h3>{formatDate(data.end_booking_date)}</h3>
                          </div>
                        )}
                      </div>
                      <div className="mybooking_card_row">
                        {data.booking_time && (
                          <div className="mybooking_cardinfo1">
                            <p>Time</p>
                            <h3>{data.booking_time}</h3>
                          </div>
                        )}
                        {data.service_name && (
                          <div className="mybooking_cardinfo1">
                            <p>Service</p>
                            <h3>{data.service_name}</h3>
                          </div>
                        )}
                      </div>
                      {data.address && (
                        <div className="mybooking_card_row">
                          <div className="mybooking_cardinfo1 mybooking_full_row">
                            <p>Address</p>
                            <h3>{data.address}</h3>
                          </div>
                        </div>
                      )}
                      {(data.client_name || data.client_pic) && (
                        <div className="mybooking_card_row">
                          <div className="mybooking_cardinfo1">
                            <p>Client</p>
                            <h3 className="mybooking_caretakerdata">
                              {data.client_pic ? (
                                <img
                                  src={`${process.env.REACT_APP_IMAGE_URL}${data.client_pic}`}
                                  alt="client"
                                  loading="lazy"
                                />
                              ) : null}
                              {data.client_name || "N/A"}
                            </h3>
                          </div>
                        </div>
                      )}
                      {data.description && (
                        <div className="mybooking_card_row">
                          <div className="mybooking_cardinfo1 mybooking_full_row">
                            <p>Description</p>
                            <h3>{data.description}</h3>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="mybooking_new_actions">
                      <button
                        type="button"
                        className="mybooking_new_action interested"
                        onClick={() => handleaction(data.id, "interested")}
                        disabled={actionId === data.id}
                      >
                        {actionId === data.id ? "Please wait..." : "Interested"}
                      </button>
                      <button
                        type="button"
                        className="mybooking_new_action rejected"
                        onClick={() => handleaction(data.id, "rejected")}
                        disabled={actionId === data.id}
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                getorderlist={getnewbooking}
              />
            </div>
          ) : (
            <div className="blank_booking">No New Booking Requests</div>
          )}
        </div>
      </div>
      {load && <Loader />}
      <Snackbar
        open={openSuccess}
        autoHideDuration={3000}
        onClose={() => setOpenSuccess(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="success">
          {success}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openError}
        autoHideDuration={3000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="error">
          {error}
        </Alert>
      </Snackbar>
      <KYCPopup isOpen={kyc} setisOpen={setkyc} url={url} />
    </>
  );
};

export default CaregiverNewBooking;
